// script.js
document.addEventListener('DOMContentLoaded', () => {
    // Corrected ID for the edge-styled FAB
    const whatsappFab = document.getElementById('whatsappEdgeFab');
    const whatsappPopup = document.getElementById('whatsappPopup');
    const closeWhatsappPopup = document.getElementById('closeWhatsappPopup');
    const whatsappContactList = document.getElementById('whatsappContactList');

    // --- Contact list for customization ---
    const contacts = [
        
        {
            name: "Muzammil",
            subtitle: "Order Confirmation",
            number: "923233800415",
            displayTime: "10:30 am - 7:30 pm",
            startTime: "10:30", // 24-hour format for logic
            endTime: "19:30"   // 24-hour format for logic
        },
        {
            name: "Abdul Rehman",
            subtitle: "Customer Care",
            number: "923150331777",
            displayTime: "24/7 Availible",
            startTime: "00:00",
            endTime: "23:59:59"
        },
        {
            name: "Sheess",
            subtitle: "Perfume Expert",
            number: "923035558408",
            displayTime: "12:00 am - 11:00 pm",
            startTime: "12:00",
            endTime: "23:00"  
        },
    ];

    // --- Function to check if current time is within working hours ---
    function checkAvailability(startTime, endTime) {
        const now = new Date();
        const start = new Date();
        const end = new Date();

        const [startHours, startMinutes] = startTime.split(':');
        start.setHours(startHours, startMinutes, 0);

        const [endHours, endMinutes] = endTime.split(':');
        end.setHours(endHours, endMinutes, 0);

        // If current time is between start and end time, return 'available'
        if (now >= start && now <= end) {
            return 'available';
        }
        return 'unavailable';
    }


    // --- MODIFIED: Function to populate the contact list with an <img> tag ---
    function populateContacts() {
        whatsappContactList.innerHTML = '';
        contacts.forEach(contact => {
            const listItem = document.createElement('li');
            const link = document.createElement('a');
            link.href = `https://wa.me/${contact.number}?text=${encodeURIComponent("Hello, I'm contacting you from the website.")}`;
            link.target = "_blank";

            const availabilityClass = checkAvailability(contact.startTime, contact.endTime);

            // MODIFIED: Replaced the <i> tag with an <img> tag for the list icon
            link.innerHTML = `
                <img src="https://cdn.shopify.com/s/files/1/0904/3168/4923/files/bioshop-whatsapp-button-green.webp?v=1749725740" alt="WhatsApp" class="whatsapp-list-icon">
                <div class="contact-info">
                    <span class="contact-name">${contact.name}</span>
                    <span class="contact-subtitle">${contact.subtitle}</span>
                </div>
                <div class="contact-timing ${availabilityClass}">
                    ${contact.displayTime}
                </div>
            `;

            listItem.appendChild(link);
            whatsappContactList.appendChild(listItem);
        });
    }

    // --- Event Listeners (No changes needed here) ---
    whatsappFab.addEventListener('click', (event) => {
        event.stopPropagation();
        whatsappPopup.classList.toggle('active');
    });

    closeWhatsappPopup.addEventListener('click', () => {
        whatsappPopup.classList.remove('active');
    });

    document.addEventListener('click', (event) => {
        if (whatsappPopup.classList.contains('active') &&
            !whatsappPopup.contains(event.target) &&
            event.target !== whatsappFab && !whatsappFab.contains(event.target)) {
            whatsappPopup.classList.remove('active');
        }
    });

    // --- Initialize ---
    populateContacts();
    setInterval(populateContacts, 60000); // Refreshes status every minute
});